"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Placement = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: transparent;\n\t", "\n"], ["\n\tbackground-color: transparent;\n\t", "\n"])), function (props) { return props.theme.message.placement; });
var Msg = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\tvisibility: visible;\n\twhite-space: nowrap;\n\tpointer-events: auto;\n\t", "\n"], ["\n\t", "\n\tvisibility: visible;\n\twhite-space: nowrap;\n\tpointer-events: auto;\n\t", "\n"])), function (props) { return props.closed && 'display: none;'; }, function (props) { return props.theme.message.box; });
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            if (_this.props.closable) {
                _this.setState({ closed: true });
            }
        };
        _this.state = {
            closed: false
        };
        return _this;
    }
    Message.prototype.render = function () {
        return (react_1.default.createElement(Placement, null,
            react_1.default.createElement(Msg, { id: this.props.id, "data-automationid": this.props.automationId, className: this.props.className, onClick: this.onClick, closed: this.state.closed }, this.props.children)));
    };
    return Message;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Message);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Message.js.map